  //Accordion
  const accordionTitles = document.querySelectorAll(".accordion-title");

  accordionTitles.forEach(title => {
    title.addEventListener("click", () => {
      const item = title.parentElement;
      const openItem = document.querySelector(".accordion-item.active");

      // Close any other open accordion
      if (openItem && openItem !== item) {
        openItem.classList.remove("active");
      }

      // Toggle the current one
      item.classList.toggle("active");
    });
  });

 // Box slider 
document.addEventListener("DOMContentLoaded", function() {
  $('.box-slider').owlCarousel({
    items: 3,
    margin: 20,
    loop: true,
    autoplay: true,
    autoplayTimeout: 4000,
    autoplayHoverPause: true,
    dots: false,
    nav: false,
    responsive:{
      0:{ items:1 },
      768:{ items:1.5 },
      1200:{ items:2.2 }
    }
  });
});

// Video gallery popup
  document.addEventListener("DOMContentLoaded", function() {
    const popup = document.querySelector('.video-popup');
    const iframe = document.getElementById('popup-video');
    const closePopup = document.querySelector('.close-popup');

    document.querySelectorAll('.video-wrapper').forEach(wrapper => {
      wrapper.addEventListener('click', function() {
        let videoUrl = this.getAttribute('data-video');

        // ✅ Extract the YouTube video ID from any URL format
        const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?v=))([^#&?]*).*/;
        const match = videoUrl.match(regExp);
        const videoId = (match && match[7].length == 11) ? match[7] : null;

        if (videoId) {
          const embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
          iframe.src = embedUrl;
          popup.style.display = 'flex';
        } else {
          console.warn("Invalid YouTube URL:", videoUrl);
        }
      });
    });

    closePopup.addEventListener('click', function() {
      popup.style.display = 'none';
      iframe.src = '';
    });

    popup.addEventListener('click', function(e) {
      if (e.target === popup) {
        popup.style.display = 'none';
        iframe.src = '';
      }
    });
  });


// testimonials
$(document).ready(function(){
  $('.testi-slider').owlCarousel({
    items: 1,
    loop: true,
    autoplay: false,
    autoplayTimeout: 5000,
    dots: true,
    nav: false
  });
});




//Why plenity product slider
$(document).ready(function() {
  var plenitySlider = $('.product-owl-slider');

  plenitySlider.owlCarousel({
    loop: true,
    margin: 20,
    nav: false,
    dots: true,
    autoplay: true,
    autoplayTimeout: 3000,
    responsive: {
      0: {
        items: 1
      },
      768: {
        items: 1
      },
      1200: {
        items: 1
      }
    }
  });

  $('.product-slider-prev').on('click', function() {
    plenitySlider.trigger('prev.owl.carousel');
  });

  $('.product-slider-next').on('click', function() {
    plenitySlider.trigger('next.owl.carousel');
  });
});



//logo_slider 
$('.logo_slider .owl-carousel').owlCarousel({
  loop: true,
  margin: 10,
  nav: false,
  dots: true,
  smartSpeed: 800,
  autoplay: true,
  autoplayTimeout: 3000,
  responsive: {
    0: {
      items: 1
    },
    768: {
      items: 2
    },
    1200: {
      items: 1
    }
  }
});


// video popup script

// JavaScript
document.addEventListener("DOMContentLoaded", function () {
  const playArea = document.querySelector(".play-area");
  const popup = document.querySelector(".custom-video-popup");
  const closeBtn = document.querySelector(".custom-close-popup");
  const iframe = document.getElementById("custom-video-frame");

  function getEmbedUrl(url) {
    // YouTube
    if (url.includes("youtube.com/watch") || url.includes("youtu.be")) {
      let videoId;
      if (url.includes("youtu.be")) {
        videoId = url.split("/").pop().split("?")[0];
      } else {
        const params = new URLSearchParams(url.split("?")[1]);
        videoId = params.get("v");
      }
      return `https://www.youtube.com/embed/${videoId}?autoplay=1`;
    }

    // Vimeo
    if (url.includes("vimeo.com")) {
      const videoId = url.split("/").pop().split("?")[0];
      return `https://player.vimeo.com/video/${videoId}?autoplay=1`;
    }

    // Other URLs (direct iframe compatible)
    return url;
  }

  // Open popup
  playArea.addEventListener("click", function () {
    const videoUrl = this.getAttribute("data-video");
    iframe.src = getEmbedUrl(videoUrl);
    popup.style.display = "flex";
    document.body.style.overflow = "hidden"; // prevent background scroll
  });

  // Close popup
  function closePopup() {
    popup.style.display = "none";
    iframe.src = ""; // stop video
    document.body.style.overflow = "";
  }

  closeBtn.addEventListener("click", closePopup);

  // Close when clicking outside content
  popup.addEventListener("click", function (e) {
    if (!e.target.closest(".custom-video-popup-content")) {
      closePopup();
    }
  });
});
